__turbopack_context__.v({
  "gray": "cx1SGG_gray",
  "green": "cx1SGG_green",
  "iconButton": "cx1SGG_iconButton",
  "transparent": "cx1SGG_transparent",
});
